import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

export interface SegmentedFilterBadgeProps {
  /** The number to display on the badge. */
  value?: number;
  /** Should the "selected" style be applied */
  isSelectedFilter?: boolean;
}

/*
 * Style.
 */

interface BadgeStyleProps {
  $isSelectedFilter: boolean;
}
const StyledBadgeDiv = styled.div<BadgeStyleProps>`
  flex-shrink: 0;

  margin-left: 4px;
  min-width: 14px;
  line-height: 14px;
  padding: 0 4px;
  border-radius: 7px;
  background-color: ${(p) => (p.$isSelectedFilter ? p.theme.greys.shade60 : p.theme.greys.shade40)};

  color: ${(p) => p.theme.greys.white};
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.semibold};
`;

/*
 * Component.
 */

/** Badge for the P2 Search Filter counts */
export const SegmentedFilterBadge: FC<SegmentedFilterBadgeProps> = (props) => {
  const {value, isSelectedFilter} = props;

  if (!value || value === 0) {
    return null;
  }

  const label = value > 99 ? '99+' : value;
  return <StyledBadgeDiv $isSelectedFilter={Boolean(isSelectedFilter)}>{label}</StyledBadgeDiv>;
};
